module.exports = __webpack_public_path__ + "static/section_1-6c5b95df3df631bae5a3def241969c1a.png";